import { AspectRatio, GenerationMode, ImageSize } from "./enums.mjs";
import { LoraItemSchema } from "./lora.mjs";
import { StyleSchema } from "./style.mjs";
import { z } from "zod";
//#region src/api/orpc/image/request.ts
/**
* Fields shared between the **public V2** and **internal** image creation
* APIs. Internal callers extend this with extra control fields (userId,
* billing override, etc.) — see `pixai-server/.../internal/image.ts`.
*/
const ImageCreateCoreSchema = z.object({
	prompt: z.string().min(1).max(4096),
	negativePrompt: z.string().max(4096).optional(),
	mode: GenerationMode.optional(),
	style: StyleSchema.optional(),
	loras: z.array(LoraItemSchema).max(5).optional(),
	seed: z.number().int().optional(),
	watermark: z.enum(["pixai"]).optional(),
	promptHelper: z.enum(["enable", "disable"]).default("enable"),
	callbackUrl: z.url().optional()
});
/**
* V2 base layer — Core + V2-only `aspectRatio` / `size`. Split from the
* fully-refined request so server-side helpers (which already know the
* model id) can consume the partial shape without re-running the
* `modelId ?? modelVersionId` cross-field refinement.
*/
const V2ImageCreateBaseSchema = ImageCreateCoreSchema.extend({
	aspectRatio: AspectRatio.default("1:1"),
	size: ImageSize.default("1k")
});
/**
* Full request schema for `POST /image/create`. Adds the optional
* `modelId` / `modelVersionId` fields and the cross-field rule "at least
* one of them must be provided".
*/
const V2ImageCreateRequestSchema = V2ImageCreateBaseSchema.extend({
	modelId: z.string().min(1).optional(),
	modelVersionId: z.string().min(1).optional()
}).refine((d) => d.modelId ?? d.modelVersionId, { message: "Either modelId or modelVersionId must be provided" });
//#endregion
export { ImageCreateCoreSchema, V2ImageCreateBaseSchema, V2ImageCreateRequestSchema };
